/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyleminimal3Inputs */

const en_aiflowstyleminimal3 = /** @type {(inputs: Aiflowstyleminimal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimal`)
};

const de_aiflowstyleminimal3 = /** @type {(inputs: Aiflowstyleminimal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimal`)
};

/**
* | output |
* | --- |
* | "Minimal" |
*
* @param {Aiflowstyleminimal3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyleminimal3 = /** @type {((inputs?: Aiflowstyleminimal3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyleminimal3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyleminimal3(inputs)
	return de_aiflowstyleminimal3(inputs)
});
export { aiflowstyleminimal3 as "aiFlowStyleMinimal" }